import { CheckInInterface } from '@careapp/angular-sdk';

import { CareAppListActionFactory } from './action-factory';

class CheckInsActions extends CareAppListActionFactory<CheckInInterface> {
  constructor() {
    super(`CheckIns`);
  }
}
export const CheckIns = new CheckInsActions();
